export default "__VITE_ASSET__CAiNj4S1__"